export default {
  paddingTiny: '0 6px',
  paddingSmall: '0 10px',
  paddingMedium: '0 14px',
  paddingLarge: '0 18px',
  paddingRoundTiny: '0 10px',
  paddingRoundSmall: '0 14px',
  paddingRoundMedium: '0 18px',
  paddingRoundLarge: '0 22px',
  iconMarginTiny: '6px',
  iconMarginSmall: '6px',
  iconMarginMedium: '6px',
  iconMarginLarge: '6px',
  iconSizeTiny: '14px',
  iconSizeSmall: '18px',
  iconSizeMedium: '18px',
  iconSizeLarge: '20px',
  rippleDuration: '.6s'
}
